// Packages
import tw, { styled } from 'twin.macro'

export const SuspenseContainer = styled.div(() => [
  `max-width:1280px;`,
  `> div > div { margin-bottom: 1rem; }`,
  // tw`flex flex-wrap pt-0 pl-2 pr-2 gap-4`
  tw`flex flex-wrap`,
])

export const Container = styled.div(() => [
  `min-height:100px;`,
  // tw`grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4`,
  tw`mx-auto max-w-5xl pt-7`,
])

export const ErrorMsg = styled.div(() => [
  ``,
  tw`flex justify-center text-gray-700 font-medium py-4`,
])

export const Card = styled.div(({ isGhost, location }) => [
  isGhost
    ? `* {opacity:0; pointer-events:none;}`
    : `height:100%; transition: transform 0.2s ease-in-out; @media (min-width: 768px) { &:hover{transform: scale(1.05);} }`,

  'width: 100%;',
  tw`flex flex-col text-copy bg-white p-4 pt-3 rounded border border-[#ECEDEE] shadow-sm`,
])

export const CardBody = styled.div(() => [
  `
  `,
  tw`flex flex-col flex-1 text-center text-[#333333] relative`,
])

export const CardFooter = styled.div(() => [``, tw`mt-auto pt-4 text-center`])

export const Title = styled.div(() => [
  `letter-spacing:-0.41px; justify-content:center;`,
  `:first-line {padding-right:80px}`,
  tw`flex text-base font-normal my-2 font-sans leading-snug row-auto`,
])

export const Address = styled.div(() => [
  ``,
  tw`font-light text-base leading-[110%]`,
])

export const Detail = styled.div(() => [
  `a{color:#006FCF}+ div {margin-top:0.6875rem;}`,
  `
    a {
      &:focus {
        outline: 1px dashed currentColor;
        outline-offset: 3px;
      }
    }
  `,
  tw`text-base font-light content-center justify-center my-6`,
])

export const MapLink = styled.div(() => [
  `a{color:#006FCF}+ div {margin-top:0.6875rem;}`,
  `
    a {
      &:focus {
        outline: 1px dashed currentColor;
        outline-offset: 3px;
      }
    }
  `,
  `:hover {
    background-color: rgba(236, 237, 238, 0.7);
  }
  `,
  `
    padding: 0.5rem 0;
    margin-bottom: 0.5rem;
  `,
  tw`text-base font-light flex content-center justify-center rounded`,
])

export const Instruction = styled.div(({ marginBottom, weight }) => [
  `font-weight:${weight ? weight : 400};margin-bottom:${
    marginBottom ? marginBottom : 0
  }px;`,
  'span { flex: 1 auto; text-align: center;}',
  'span.has-icon { margin-left: -1.625rem; max-width: calc(100% - 18px); }',
  `svg { align-self: baseline }`,
  tw` flex justify-between`,
])

export const DetailSVG = styled.svg(() => [
  `min-width:16px;`,
  `> .margin-right {margin-right: 8px;}`,
  tw`inline-block`,
])

export const Button = styled.a(() => [
  `> svg {margin-left: 8px}`,
  `
  :focus {
    outline: 1px dashed #333;
    outline-offset: 3px;
  }
  `,
  `
  :hover {
    background-color: rgba(200, 201, 199, 0.75);
  }
  `,
  tw`h-12 flex mt-2 justify-center items-center text-[#333333] text-center leading-[3rem] bg-[#ECEDEE] rounded whitespace-nowrap overflow-hidden overflow-ellipsis pl-3 pr-3 w-full cursor-pointer
  transition-all duration-200
  `,
])

export const ModalButton = styled.button(() => [
  `> svg {margin-left: 8px}`,
  `
  :focus {
    outline: 1px dashed #333;
    outline-offset: 3px;
  }
  `,
  tw`h-12 flex mt-2 justify-center text-[#333333] text-center leading-[3rem] bg-[#ECEDEE] rounded whitespace-nowrap overflow-hidden overflow-ellipsis pl-3 pr-3 w-full cursor-pointer
  transition-all duration-200
  `,
])

export const ButtonDisabled = styled.span(() => [
  `background-color:rgba(0,0,0,0.5);`,
  tw`h-12 block mt-2 text-white text-center leading-10 rounded whitespace-nowrap overflow-hidden overflow-ellipsis pl-3 pr-3 w-full`,
])

export const New = styled.div(() => [
  `padding: 6px 12px 7px; font-family: BentonSans; font-size: 12px; font-weight: 700; line-height: 1;`,
  `background: #53565A; box-shadow: 0px 1px 1px 0px rgba(0,0,0,0.1);`,
  `&[data-modal="modal"] {top:-23px;} `,
  tw`text-white text-center uppercase rounded-2xl whitespace-nowrap overflow-hidden flex items-center`,
])

export const DistanceBadge = styled.div(() => [
  `padding: 6px 12px 7px; font-family: BentonSans; font-size: 12px; font-weight: 500; line-height: 1;`,
  `background: #ecedee; box-shadow: 0px 1px 1px 0px rgba(0,0,0,0.1);`,
  tw`mr-2 text-center rounded-2xl whitespace-nowrap overflow-hidden flex items-center`,
])
export const SpecialOffer = styled.div(() => [
  `padding: 6px 12px 7px; font-family: BentonSans; font-size: 12px; font-weight: 500; line-height: 1;`,
  `background: #ecedee; box-shadow: 0px 1px 1px 0px rgba(0,0,0,0.1);`,
  `&[data-modal="modal"] {top:-23px;} `,
  tw`mr-2  text-center uppercase rounded-2xl whitespace-nowrap overflow-hidden flex items-center`,
])

export const Flags = styled.div((modal) => {
  const isGroup = modal.type === 'group'
  const styles = isGroup
    ? tw`w-full flex absolute top-[-16px] md:top-[-25px] md:justify-end justify-center`
    : tw`w-full flex absolute top-[-25px] justify-center`

  return [``, styles]
})

export const Flag = styled.div(() => [
  `padding: 6px 12px 7px; font-family: BentonSans; font-size: 12px; font-weight: 500; line-height: 1;`,
  `background: #ECEDEE; box-shadow: 0px 1px 1px 0px rgba(0,0,0,0.1);`,
  tw`text-[#333333] text-center uppercase rounded-2xl whitespace-nowrap overflow-hidden flex items-center`,
])

export const MidFlags = styled.div(() => [
  tw`flex flex-wrap gap-2 mt-2 justify-center`,
])

export const AddressSection = styled.div(() => [``])

export const CuisineRow = styled.div(() => [
  tw`flex flex-wrap justify-center items-center gap-2 mt-2`,
])

export const CuisineItem = styled.div(() => [
  tw`flex items-center text-base font-light`,
])

export const LocationInfo = styled.div(() => [``, tw``])

export const LocationOuter = styled.div(() => [``, tw`flex flex-1`])

export const LocationInner = styled.div(() => [``, tw`flex flex-col flex-1`])

export const HotelRestaurantStar = styled.div(() => [tw`pl-3`])

export const CardBodyGrouped = styled.div(() => [
  `flex-direction: column; flex: 1;`,
  tw`flex text-center relative`,
])
